// extracted by mini-css-extract-plugin
export default {"wrapper":"Switch_wrapper__l6vlL","switcherChecked":"Switch_switcherChecked__pSejZ"};